import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { auth, db } from './firebase';

const PlatformDashboard = () => {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // New Tenant Form
  const [districtName, setDistrictName] = useState('');
  const [adminName, setAdminName] = useState('');
  const [adminEmail, setAdminEmail] = useState('');
  
  const [isDeploying, setIsDeploying] = useState(false);
  const [message, setMessage] = useState('');

  const fetchTenants = async () => {
    setLoading(true);
    try {
      const snap = await getDocs(collection(db, 'tenants'));
      const tenantList = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setTenants(tenantList);
    } catch (err) {
      console.error("Error fetching tenants:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTenants();
  }, []);

  const handleDeployTenant = async () => {
    if (!districtName || !adminName || !adminEmail) {
      setMessage("Please fill out all fields to deploy a new district.");
      return;
    }

    setIsDeploying(true);
    setMessage('Forging new district tenant in Google Cloud...');

    try {
      const functions = getFunctions();
      const deployDistrict = httpsCallable(functions, 'deployNewDistrict');
      
      await deployDistrict({
        districtName: districtName,
        adminName: adminName,
        adminEmail: adminEmail
      });

      setMessage(`${districtName} deployed! The SuperAdmin can now log in with password: ChangeMe123!`);
      setDistrictName('');
      setAdminName('');
      setAdminEmail('');
      fetchTenants(); 
      
      setTimeout(() => setMessage(''), 8000);
    } catch (err) {
      console.error("Error deploying tenant:", err);
      setMessage("Deployment failed. Are you logged in with Master HQ credentials?");
    } finally {
      setIsDeploying(false);
    }
  };

  const handleSignOut = () => {
    auth.signOut();
  };

  if (loading) return <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'sans-serif', color: '#fff' }}>Loading Command Center...</div>;

  return (
    <div style={{ backgroundColor: '#1a1a1a', minHeight: '100vh', padding: '40px 20px', fontFamily: 'sans-serif', color: '#fff' }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #333', paddingBottom: '20px', marginBottom: '40px' }}>
          <div>
            <h1 style={{ margin: 0, color: '#00d2ff', fontSize: '32px', letterSpacing: '-1px' }}>CaseSync HQ</h1>
            <p style={{ margin: '5px 0 0 0', color: '#888', fontSize: '14px' }}>Platform Administration & Tenant Deployment</p>
          </div>
          <button 
            onClick={handleSignOut}
            style={{ padding: '8px 16px', backgroundColor: 'transparent', color: '#ba0c2f', border: '1px solid #ba0c2f', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
          >
            Lock Down HQ
          </button>
        </div>

        <div style={{ backgroundColor: '#242424', padding: '30px', borderRadius: '8px', border: '1px solid #333', marginBottom: '40px' }}>
          <h2 style={{ margin: '0 0 20px 0', color: '#fff', fontSize: '20px' }}>🚀 Deploy New District</h2>
          
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 200px' }}>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '8px', color: '#aaa' }}>District Name</label>
              <input 
                placeholder="e.g., Marion County Schools" 
                value={districtName} 
                onChange={(e) => setDistrictName(e.target.value)} 
                style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #444', backgroundColor: '#111', color: '#fff', boxSizing: 'border-box' }} 
              />
            </div>
            
            <div style={{ flex: '1 1 200px' }}>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '8px', color: '#aaa' }}>SuperAdmin Name</label>
              <input 
                placeholder="e.g., Tech Director" 
                value={adminName} 
                onChange={(e) => setAdminName(e.target.value)} 
                style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #444', backgroundColor: '#111', color: '#fff', boxSizing: 'border-box' }} 
              />
            </div>

            <div style={{ flex: '1 1 200px' }}>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '8px', color: '#aaa' }}>SuperAdmin Email</label>
              <input 
                type="email" 
                placeholder="director@district.kyschools.us" 
                value={adminEmail} 
                onChange={(e) => setAdminEmail(e.target.value)} 
                style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #444', backgroundColor: '#111', color: '#fff', boxSizing: 'border-box' }} 
              />
            </div>
          </div>

          <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: message.includes('Failed') ? '#ba0c2f' : '#00d2ff', fontWeight: 'bold' }}>{message}</span>
            <button 
              onClick={handleDeployTenant}
              disabled={isDeploying}
              style={{ padding: '12px 25px', backgroundColor: '#00d2ff', color: '#000', border: 'none', borderRadius: '4px', cursor: isDeploying ? 'not-allowed' : 'pointer', fontWeight: 'bold', fontSize: '15px' }}
            >
              {isDeploying ? 'Deploying...' : 'Initialize Tenant'}
            </button>
          </div>
        </div>

        <div>
          <h2 style={{ margin: '0 0 20px 0', color: '#fff', fontSize: '20px' }}>Active Tenants ({tenants.length})</h2>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {tenants.map(tenant => (
              <div key={tenant.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px', backgroundColor: '#242424', border: '1px solid #333', borderRadius: '8px' }}>
                <div>
                  <div style={{ fontWeight: 'bold', color: '#fff', fontSize: '18px', marginBottom: '5px' }}>{tenant.name}</div>
                  <div style={{ color: '#888', fontSize: '13px', fontFamily: 'monospace' }}>Tenant ID: {tenant.id}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ color: '#aaa', fontSize: '13px', marginBottom: '5px' }}>Lead: {tenant.leadAdmin}</div>
                  <span style={{ padding: '4px 8px', backgroundColor: 'rgba(40, 167, 69, 0.2)', color: '#28a745', borderRadius: '12px', fontSize: '11px', fontWeight: 'bold', textTransform: 'uppercase' }}>
                    {tenant.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default PlatformDashboard;